import { dataExpandSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExpandSquareSolid = /*#__PURE__*/createIcon(dataExpandSquareSolid)
export default IconExpandSquareSolid
